// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_zqAlR","title":"title_1Kbdm","submit":"submit_21W9G","list":"list_2th-Z","item":"item_1ml4P","order":"order_3x6by","desc":"desc_1KIPZ"};